import React, { useState, createContext, useContext } from "react";

const EditingContext = createContext({
	researchTeam: [ false ],
	sponsorCosts: [ false ],
	internalCostShare: [ false ],
	externalCostShare: [ false ],
});

export const useEditingContext = () => useContext(EditingContext);

export const EditingContextWrapper = ({ children }) => {
	const researchTeam = useState(false);
	const sponsorCosts = useState(false);
	const internalCostShare = useState(false);
	const externalCostShare = useState(false);

	return (
		<EditingContext.Provider
			value={{
				researchTeam,
				sponsorCosts,
				internalCostShare,
				externalCostShare,
			}}
		>
			{children}
		</EditingContext.Provider>
	);
};
